import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/router/routes'
import {
  createBeforeEachGuard,
  createScrollBehavior
} from '@/router/navigation'

export function createRouterOptions() {
  return {
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior: createScrollBehavior()
  }
}

export function createAppRouter(appStore) {
  const router = createRouter(createRouterOptions())
  router.beforeEach(createBeforeEachGuard(appStore))
  return router
}
